import React from "react";
import "./About_content.css";
import Common_title from "../../common-components/common-title/Common_title";

const About_content = () => {
  return (
    <>
      <section className="About_content_sec">
        <div className="container">
          <Common_title title="ABOUT US" subtitle="Welcome!" />

          <div className="row mt-4">
            <div className="col-md-12 mx-auto">
              <div className="cont_div">
                <p className="abtcont">
                  Loconex is a digital platform created with one clear
                  purpose to support and grow local businesses instead of large
                  online marketplaces, while giving customers better value,
                  trust, and convenience. We believe local shops, vendors, and
                  service providers deserve the same digital power as big online
                  businesses. Loconex helps them reach nearby customers
                  directly, offer discounts, and manage bookings easily.
                </p>

                <p className="abtcont">
                  Loconex is a city-first hyperlocal digital platform
                  created to bring every part of the city into one trusted
                  ecosystem. Our goal is to ensure that citizens, farmers,
                  businesses, service providers, and public authorities stay
                  digitally connected on a single platform. Instead of searching
                  across multiple sources, residents can instantly find local
                  products, essential services, emergency contacts, government
                  offices, and verified people within their city. Loconex
                  helps communities function faster, safer, and smarter.
                </p>
                <p className="abtcont">
                  Whether you are a customer looking for nearby goods, a farmer
                  searching for local buyers, a shop owner reaching customers,
                  or a citizen needing city support — Loconex makes
                  everything accessible in one place.
                </p>

                <div className="abt-extra-content">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="yellow_card">
                        <h4 className="abt-heading">
                          Loconex focuses on strengthening the local
                          ecosystem by:
                        </h4>

                        <ul className="abt-list">
                          <li>
                            Connecting local customers with nearby sellers
                          </li>
                          <li>
                            Helping farmers reach urban markets and buyers
                          </li>
                          <li>Supporting small businesses to grow digitally</li>
                          <li>Encouraging citizens to buy within their city</li>
                          <li>
                            Creating opportunities for vendors and service
                            experts
                          </li>
                          <li>
                            Building a stronger local economy through technology
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="yellow_card">
                        <h4 className="abt-heading">
                          City Services & Public Access
                        </h4>

                        <p className="abtcont">
                          Through Loconex, citizens can easily access:
                        </p>

                        <ul className="abt-list">
                          <li>
                            Ambulance, police, fire, and emergency numbers
                          </li>
                          <li>Government departments and office contacts</li>
                          <li>
                            Legal, medical, and civic service professionals
                          </li>
                          <li>Journalists and verified media contacts</li>
                          <li>
                            Political representatives and community leaders
                          </li>
                          <li>Gram Panchayat and municipal members</li>
                          <li>
                            Social organizations and public service groups
                          </li>
                        </ul>

                        <p className="abtcont">
                          All essential city information is organized in one
                          secure platform.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
              </div>

              <div className="about-sections">
                {/* Section 1 */}
                <section className="feature-section support_section bg-light">
                  <div className="feature-container">
                    <div className="feature-image">
                      <img
                        src="/assets/images/icons/mobile2.png"
                        alt=""
                      />
                    </div>
                    <div className="feature-content">
                      <h5>Supporting Local Businesses</h5>
                      <p>
                        Unlike big online platforms, Loconex focuses on:
                      </p>
                      <ul className="feature-list">
                        <li>
                          <span className="feature-icon">✓</span>
                          <div>
                            <strong>Promoting Nearby Shops</strong>
                            <p>
                              Helping customers easily discover local shops and
                              services.
                            </p>
                          </div>
                        </li>

                        <li>
                          <span className="feature-icon">✓</span>
                          <div>
                            <strong>Digital Empowerment</strong>
                            <p>
                              Giving small businesses the tools to compete
                              digitally.
                            </p>
                          </div>
                        </li>

                        <li>
                          <span className="feature-icon">✓</span>
                          <div>
                            <strong>Encouraging Local Buying</strong>
                            <p>
                              Motivating customers to support their own
                              community.
                            </p>
                          </div>
                        </li>

                        <li>
                          <span className="feature-icon">✓</span>
                          <div>
                            <strong>Community Growth</strong>
                            <p>
                              Every order contributes to strengthening local
                              businesses.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>

                {/* Section 2 */}
                <section className="discount-block">
                  <div className="discount-wrapper">
                    <div className="discount-content-box">
                      <h5>Discounts, Offers & Booking</h5>

                      <p className="discount-subtitle">
                        Through Loconex, users can:
                      </p>

                      <ul className="discount-list">
                        <li>View exclusive discounts from local vendors</li>
                        <li>Book services from nearby experts</li>
                        <li>Get better pricing than big platforms</li>
                        <li>Enjoy faster & personal support</li>
                      </ul>

                      <div className="business-box">
                        <p>
                          <strong>Local businesses can:</strong>
                        </p>
                        <ul className="business-list">
                          <li>Create offers and coupons</li>
                          <li>Manage bookings and orders</li>
                          <li>Reach real customers nearby</li>
                        </ul>
                      </div>
                    </div>

                    <div className="discount-image-box">
                      <img
                        src="/assets/images/about-us/discount/img2.png"
                        alt="Discount Offers"
                      />
                      {/* <div className="discount-badge">Special Offers</div> */}
                    </div>
                  </div>
                </section>

                {/* Section 3 */}
                <section className="whatwedo-section local-benefits">
                  <div className="whatwedo-container">
                    <div class="section-header text-center">
                      <h2 className="local-benefits-title">What We Do</h2>
                    </div>

                    <div className="whatwedo-grid">
                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">👥</div>
                        <p>Connect customers with local sellers</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🛍️</div>
                        <p>Empower vendors and service experts</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🔐</div>
                        <p>Secure payments & wallet system</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🌐</div>
                        <p>All on one powerful platform</p>
                      </div>
                    </div>

                    <p className="subtitle">Loconex connects:</p>

                    <div className="whatwedo-grid">
                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">👥</div>
                        <p>Citizens and customers</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🛍️</div>
                        <p> Farmers and local markets</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🔐</div>
                        <p>Shops, vendors, and service providers</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🌐</div>
                        <p>Government and public offices</p>
                      </div>

                      <div className="whatwedo-card">
                        <div className="whatwedo-icon">🌐</div>
                        <p>Community leaders and residents</p>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Section – What Makes Different */}
                <section className="difference-section">
                  <div className="difference-overlay">
                    <div className="difference-container">
                      <div className="difference-content">
                        <h5 className="difference-title">
                          What Makes Loconex Different
                        </h5>

                        <ul className="difference-list">
                          <li>Nearby-first discovery</li>
                          <li>Support local over big platforms</li>
                          <li>WhatsApp-based inquiry system</li>
                          <li>Faster service & personal trust</li>
                          <li>Simple for vendors, powerful for customers</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Core Belief Section */}
                <section className="corebelief-section">
                  <div className="corebelief-container">
                    <h5 className="corebelief-title">Our Core Belief</h5>

                    <div className="corebelief-cards">
                      <div className="corebelief-card">
                        <span className="belief-icon">🌱</span>
                        <p>When local businesses grow, communities grow.</p>
                      </div>

                      <div className="corebelief-card">
                        <span className="belief-icon">🏪</span>
                        <p>Local sellers must win in the digital world.</p>
                      </div>

                      <div className="corebelief-card">
                        <span className="belief-icon">🤝</span>
                        <p>
                          When local people connect locally, cities become
                          stronger.
                        </p>
                      </div>

                      {/* New Card 2 */}
                      <div className="corebelief-card">
                        <span className="belief-icon">🌍</span>
                        <p>
                          Loconex exists to ensure that every citizen can
                          access their city, support their economy, and grow
                          together in a digital world.
                        </p>
                      </div>
                    </div>

                  <h6 className="footer_text">One City • One Platform • For Everyone</h6>  
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About_content;
